import { IDefaultCarrierCredentials } from "@redotech/redo-model/carrier-account/create-carrier-account";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const USPSCarrierInput = groupInput({
  companyName: input<string>({ validator: nonEmptyValidator }),
  addressStreet: input<string>({ validator: nonEmptyValidator }),
  addressCity: input<string>({ validator: nonEmptyValidator }),
  addressState: input<string>({ validator: nonEmptyValidator }),
  addressZip: input<string>({ validator: nonEmptyValidator }),
  phone: input<string>({ validator: nonEmptyValidator }),
  email: input<string>({ validator: nonEmptyValidator }),
  shipperId: input<string>(),
});

export type USPSCarrierValue = InputSchema.Value<typeof USPSCarrierInput>;

export type USPSCarrierForm = InputSchema.Input<typeof USPSCarrierInput>;

export const uspsCarrierDefault = (
  defaults?: IDefaultCarrierCredentials,
): USPSCarrierValue => ({
  companyName: defaults?.company_name || "",
  addressStreet: defaults?.address_street || "",
  addressCity: defaults?.address_city || "",
  addressState: defaults?.address_state || "",
  addressZip: defaults?.address_zip || "",
  phone: defaults?.phone || "",
  email: defaults?.email || "",
  shipperId: "",
});

export const CreateUSPSCarrierForm = memo(function CreateUSPSCarrierForm({
  carrierInput,
}: {
  carrierInput: USPSCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Company name"
        placeholder=""
        setValue={carrierInput.inputs.companyName.setValue}
        value={carrierInput.inputs.companyName.value}
      />
      <RedoTextInput
        label="Address street"
        placeholder=""
        setValue={carrierInput.inputs.addressStreet.setValue}
        value={carrierInput.inputs.addressStreet.value}
      />
      <RedoTextInput
        label="Address city"
        placeholder=""
        setValue={carrierInput.inputs.addressCity.setValue}
        value={carrierInput.inputs.addressCity.value}
      />
      <RedoTextInput
        label="Address state"
        placeholder=""
        setValue={carrierInput.inputs.addressState.setValue}
        value={carrierInput.inputs.addressState.value}
      />
      <RedoTextInput
        label="Address zip"
        placeholder=""
        setValue={carrierInput.inputs.addressZip.setValue}
        value={carrierInput.inputs.addressZip.value}
      />
      <RedoTextInput
        label="Phone"
        placeholder=""
        setValue={carrierInput.inputs.phone.setValue}
        value={carrierInput.inputs.phone.value}
      />
      <RedoTextInput
        label="Email"
        placeholder=""
        setValue={carrierInput.inputs.email.setValue}
        value={carrierInput.inputs.email.value}
      />
      <RedoTextInput
        label="Shipper ID"
        placeholder=""
        setValue={carrierInput.inputs.shipperId.setValue}
        value={carrierInput.inputs.shipperId.value}
      />
    </>
  );
});
